module.exports = __webpack_public_path__ + "img/eprf-ship.66810b81.png";